import React from 'react'

interface Props {
    ariaLabel: string
    children: React.ReactNode
}

export const NavigationList = ({ children, ariaLabel }: Props): React.ReactElement => {
    return (
        <nav aria-label={ariaLabel} className="transparent w-56 navigation-list">
            <ul>{children}</ul>
        </nav>
    )
}
